
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Provider } from "react-redux";
import { store } from "./store";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Router from './routes/Router'
import { GoogleOAuthProvider } from "@react-oauth/google";
import encryptedStrings from "@/constants/originals/EncryptedStrings";
import ThemeProvider from "@/components/theme/ThemeProvider";
import { useEffect } from "react";

const queryClient = new QueryClient();

const App = () => {

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  useEffect(() => {
    scrollToTop()
  }, [window.location.pathname])


  return (
    <GoogleOAuthProvider clientId={encryptedStrings.ClientID}>

      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          {/* Outside TooltipProvider so portalled surfaces — toasts, tooltips,
              dialogs — are inside the themed tree and read the same class. */}
          <ThemeProvider>
            <TooltipProvider>
              <Toaster />
              <Sonner position="top-right" />
              <Router />
            </TooltipProvider>
          </ThemeProvider>
        </Provider>
      </QueryClientProvider>
    </GoogleOAuthProvider>

  );
}

export default App;
